import Porlet from '@/models/Porlet';
import Entidad from '@/models/Entidad';
import axios from 'axios';
function defaultState() {
	return {
		porlets: [],
		loading: false,
		tableResumenGranos: [],
		tableResumenGranosOri: [],
		entidades: [],
	};
}
const state = defaultState();
const getters = {};
const mutations = {
	setPorlets(state: { porlets: Porlet[] }, porlets: Porlet[]) {
		state.porlets = porlets;
	},
	setLoading(state: { loading: boolean }, loading: boolean) {
		state.loading = loading;
	},
	setEntidades(state: { entidades: Entidad[] }, entidades: Entidad[]) {
		state.entidades = entidades;
	},
	setLoadFicha(state: { tableResumenGranos: [] }, tableResumenGranos: []) {
		state.tableResumenGranos = tableResumenGranos;
	},
	setLoadFichaOri(state: { tableResumenGranosOri: [] }, tableResumenGranos: []) {
		state.tableResumenGranosOri = tableResumenGranos;
	},
};
const actions = {
	async changeSwitch({ commit, dispatch }, valor: boolean) {
		var filter = state.tableResumenGranosOri;
		if (valor) filter = filter.filter((item: { kilstk: number }) => item.kilstk !== 0);

		commit('setLoadFicha', filter);
	},
	async loadPorlets({ commit, dispatch }, params: { url: string; grupo_vendedor_id: number; grupo_zona_id: number }) {
		commit('setLoading', true);
		let pre_url = params.url;
		if (params.grupo_vendedor_id) pre_url = params.url + '?grupo=' + params.grupo_vendedor_id;
		if (params.grupo_zona_id) pre_url = params.url + '?grupo=' + params.grupo_zona_id;
		const url = `./api/public/proxy/cgi/${pre_url}`;
		const response = await axios.get(url);
		if (params.url == 'etenet_dashboard_vend' || params.url == 'etenet_dashboard_zona') {
			commit('setEntidades', response.data.entidades as Entidad);
			commit('setPorlets', []);
		} else {
			const porlets = response.data.porlets ? response.data.porlets : [];
			const ficha = response.data.etenet_fichares.items;
			commit('setPorlets', porlets as Porlet);
			commit('setLoadFicha', ficha);
			commit('setLoadFichaOri', ficha);
			commit('setEntidades', []);
			commit('setLoading', false);
		}
		return response;
	},
	async setPorlets({ commit, dispatch }, data: []) {
		commit('setPorlets', data);
	},
	reset(): void {
		Object.assign(state, defaultState());
	},
};
export default {
	state,
	getters,
	actions,
	mutations,
};
